import { ViewErrorInfoModal } from "./ViewErrorInfoModal";

export default ViewErrorInfoModal;
